import { ESTACIO_INICIALITZAR,
    ESTACIO_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS,
    ESTACIO_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA } from '../../../actions/actionTypes';

export const ESTAT_INICIAL = false;

const peticioEnviarFormulariEnCurs = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case ESTACIO_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS:
            return true;

        case ESTACIO_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA:
            return false;

        default:
            return state;
    }
};

export default peticioEnviarFormulariEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/estacio/formulari/peticioEnviarFormulariEnCurs.js